// Import dependencies
import { builderFetch } from '@builder/core/utilities';
const { confirm, isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.itemLoop.deleteLoopFilter;

/**
 * Deletes a loop filter
 *
 * @param {Number} loopID The loop ID (post ID)
 * @param {Number} loopFilterID The loop filter ID (post ID)
 * @return {Promise} The apiFetch promise
 */
const deleteLoopFilter = async ( loopID, loopFilterID ) => {
	// Get the loop filter
	const loopFilter = UncannyAutomator._core.recipe.item.loop.getLoopFilter( loopID, loopFilterID );

	// If the item is not define, stop here
	if ( isEmpty( loopFilter ) ) {
		throw new Error( `deleteLoopFilter: The filter ${ loopFilterID } doesn't exist` );
	}

	await confirm( {
		content: strings.irreversibleAction,
		confirmButtonLabel: strings.deleteLoopFilter
	} );

	// Save the recipe title
	return builderFetch( {
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'delete_filter',
			// eslint-disable-next-line camelcase
			loop_id: loopID,
			// eslint-disable-next-line camelcase
			loop_filter_id: loopFilterID
		},
		snackbar: {
			loading: strings.deletingLoopFilter,
			success: strings.loopFilterDeleted,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/loop/delete-loop-filter', {
				detail: {
					loopID: loopID,
					loopFilterID: loopFilterID
				}
			} ) );
		}

		return response;
	} );
}

export default deleteLoopFilter;
